import { restApi } from 'shared/api/rest-api';

/**
 * Рендер шаблона media-manager на бэкенде: `POST /api/render-template` сам собирает
 * контекст из своей базы, зовёт сервис рендера и отдаёт готовый PNG.
 *
 * Контракт сервиса рендера — `imgame-media-manager-render/docs/render-request.md`;
 * соответствие «параметр → данные» — `docs/backend-data-sources.md` там же.
 */
export interface RenderTemplateArgs {
  templateId: number;
  matchId?: number;
  matchIds?: number[];
  championshipId?: number;
  stageId?: number;
  groupId?: number;
  templateSubtypes?: string[];
  backgrounds?: string[];
}

export type RenderTemplateBody = Record<string, unknown>;

/**
 * Тело собирается строго под один режим контекста: на бэкенде ветки
 * `contextByMatchId` → `contextByMatchIds` → `contextByChampionshipId` → `contextByStageId`
 * идут подряд **без `else`**, поэтому лишний ключ молча меняет выбранный режим.
 * Ключи со значением `undefined` и пустые массивы не отправляем вовсе.
 */
export function buildRenderTemplateBody(args: RenderTemplateArgs): RenderTemplateBody {
  const body: RenderTemplateBody = { templateId: args.templateId };

  if (args.matchId !== undefined) {
    body.matchId = args.matchId;
  } else if (args.matchIds?.length) {
    body.matchIds = args.matchIds;
  } else if (args.championshipId !== undefined) {
    body.championshipId = args.championshipId;
  } else if (args.stageId !== undefined) {
    body.stageId = args.stageId;

    if (args.groupId !== undefined) {
      body.groupId = args.groupId;
    }
  }

  if (args.templateSubtypes?.length) {
    body.templateSubtypes = args.templateSubtypes;
  }

  if (args.backgrounds?.length) {
    body.backgrounds = args.backgrounds;
  }

  return body;
}

const renderTemplateApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    renderTemplate: build.mutation<Blob, RenderTemplateArgs>({
      query: (args) => ({
        url: '/render-template',
        method: 'POST',
        data: buildRenderTemplateBody(args),
        // ответ — image/png; при 4xx/5xx тело ошибки тоже придёт блобом,
        // поэтому потребитель различает ошибки по status
        responseType: 'blob',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useRenderTemplateMutation } = renderTemplateApi;

export default renderTemplateApi;
